import React from 'react'
import { RouteComponentProps, useHistory } from 'react-router-dom'
import styled from 'styled-components'
import EarnSTHYPE from './EarnSTHYPE'
import { Helmet } from 'react-helmet'
import EarnLHYPE from './EarnLHYPE'

const ContainerStyled = styled.div`
  width: 100%;
  max-width: 870px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 200px;
  padding: 10px;
`

const IDs: string[] = ['stHYPE', 'LHYPE']

const Stake = ({
  match: {
    params: { id },
  },
}: RouteComponentProps<{ id: string }>) => {
  const history = useHistory()
  const [stakingId, setStakingId] = React.useState<string | null>(null)

  React.useEffect(() => {
    const findIndex = IDs.findIndex((x) => x.toUpperCase() === id.toUpperCase())
    if (findIndex === -1) {
      history.push('/')
    } else {
      setStakingId(IDs[findIndex])
    }
  }, [history, id])

  return (
    <>
      <Helmet>
        <title>Stake Tokens | HyperSwap Exchange on Hyperliquid</title>
        <meta
          name="description"
          content="Earn rewards by staking your tokens on HyperSwap Exchange. Start staking today to maximize your token yield."
        />
        <meta
          name="keywords"
          content="HyperSwap staking, stake tokens, earn rewards, crypto staking, DeFi staking, Hyperliquid EVM"
        />
        <meta property="og:title" content="Stake Tokens | HyperSwap Exchange on Hyperliquid" />
        <meta
          property="og:description"
          content="Stake your tokens and earn rewards on HyperSwap Exchange. Take advantage of DeFi opportunities."
        />
        <meta property="og:url" content={`${window.location.origin}/#/stake`} />
      </Helmet>
      <ContainerStyled>{stakingId === 'stHYPE' && <EarnSTHYPE />}</ContainerStyled>
      <ContainerStyled>{stakingId === 'LHYPE' && <EarnLHYPE />}</ContainerStyled>
    </>
  )
}
export default Stake
